/**
 * Convert an Office document (DOCX/DOC/XLSX/PPTX/…) to PDF bytes in-browser,
 * using the Nutrient SDK's headless `convertToPDF` API.
 *
 * The comparison viewer (`loadTextComparison` / `compareDocuments`) only
 * accepts PDF, so non-PDF documents must be converted first.
 *
 * Matches the repo's existing Nutrient pattern (`useCDN: true` + `licenseKey`),
 * so no self-hosted SDK assets are required.
 */
export async function convertOfficeToPdf(document: ArrayBuffer): Promise<ArrayBuffer> {
  const { default: PSPDFKit } = await import('@nutrient-sdk/viewer');

  // The SDK types `convertToPDF` as requiring a `container`, but conversion is
  // headless and needs none — cast to satisfy the (incorrect) typings.
  return PSPDFKit.convertToPDF({
    document,
    useCDN: true,
    licenseKey: import.meta.env.VITE_NUTRIENT_LICENSE_KEY,
  } as Parameters<typeof PSPDFKit.convertToPDF>[0]);
}
